// extracted by mini-css-extract-plugin
module.exports = {"title":"Clients_title__3zdzq","list":"Clients_list__IyUuA","logo":"Clients_logo__IvOMO"};